// extracted by mini-css-extract-plugin
export default {"container":"vO-z","topReviewHeading":"wO-z","criticalReview":"xO-z","favorableReview":"yO-z","vsSeparator":"zO-z"};